import { ContentBox } from 'app/agriculture/components/ContentBox/ContentBox';
import { SimpleGrid } from 'app/agriculture/components/SimpleGrid/SimpleGrid';
import { StatDisplay } from 'app/agriculture/components/StatDisplay/StatDisplay';
import { FixedLocationStat } from 'app/agriculture/components/FixedLocationStat/FixedLocationStat';
import { useContext } from 'react';
import { DeviceDetailContext } from 'app/agriculture/routes/Devices/DeviceDetails/context/DeviceDetailContextProvider';
import { useSnapshot } from 'app/agriculture/queries/snapshots/useSnapshot';
import { LocationValue } from 'app/agriculture/routes/Devices/DeviceDetails/components/display/location/LocationValue';
import { SuspenseWrapper } from 'app/agriculture/components/SuspenseWrapper/SuspenseWrapper';
import { LocationDisplaySkeleton } from 'app/agriculture/routes/Devices/DeviceDetails/components/display/LocationDisplaySkeleton';
import { convertMapLocationToPosition } from 'app/agriculture/components/utils/convertMapLocationToPosition';

export function LocationDisplay() {
    return (
        <SuspenseWrapper loadingComponent={<LocationDisplaySkeleton />}>
            <WrappedLocationDisplay />
        </SuspenseWrapper>
    );
}

function WrappedLocationDisplay() {
    const { device } = useContext(DeviceDetailContext);
    const { id, locationOverride } = device;
    const locationSnapshot = useSnapshot({
        snapshotType: 'Location',
        parentId: id,
        shelfLife: null,
    });

    const snapshotLocation = locationSnapshot?.location;

    return (
        <ContentBox.Section
            heading="Device Location"
            disableDivider
            timestamp={!locationOverride ? locationSnapshot?.timestamp : undefined}
        >
            <SimpleGrid className="LocationDisplay" columns={3}>
                <FixedLocationStat
                    name="Location Source"
                    usingLocationOverride={!!locationOverride}
                />
                <StatDisplay
                    name="GPS Location"
                    value={
                        !snapshotLocation ? null : (
                            <LocationValue
                                location={convertMapLocationToPosition(snapshotLocation)}
                            />
                        )
                    }
                />
                <StatDisplay
                    name="Fixed Location"
                    emptyStateMessage={'Not set'}
                    value={
                        !locationOverride ? null : (
                            <LocationValue
                                location={convertMapLocationToPosition(locationOverride)}
                            />
                        )
                    }
                />
                {!locationOverride ? (
                    <>
                        <StatDisplay name="Altitude" value={locationSnapshot?.altitude} unit="m" />
                        <StatDisplay name="Radius" value={locationSnapshot?.radius} unit="m" />
                        <StatDisplay
                            name="Speed"
                            value={locationSnapshot?.speed}
                            unit="m/s"
                            decimalPlaces={1}
                        />
                    </>
                ) : null}
            </SimpleGrid>
        </ContentBox.Section>
    );
}
